import ga from "@mobi/libraries/analytics/ga"
import segment from "@mobi/libraries/analytics/segment"

const appTrackers = {
  trackSegmentPage: ({ event = "", data = null }) => {
    if (data) {
      segment.page(event, { ...data })
      return
    }
    segment.page(event)
  },

  trackSegmentEvent: ({ event = "", data = null }) => {
    if (data) {
      segment.track(event, { ...data })
      return
    }
    segment.track(event)
  },

  trackGaPage: (payload) => {
    ga.page(payload)
  },

  trackGaEvent: (payload) => {
    ga.track(payload)
  },

  trackGaDefaultParameters: (payload) => {
    //TODO: Após validado pelo time de CGI, adicionar no ds para não precisar do timeOut
    setTimeout(() => {
      window?.ItauDigitalAnalytics?.setDefaultParameters(payload)
      console.log(
        "%c @analytics/ga - default parameters",
        "color: blue",
        payload,
      )
    }, 3000)
  },
}

export default appTrackers
